/**
 * The Tools section.
 *
 * One page today (bulk PDF export) and a nested router anyway, because the point
 * of the section is that it is where the next operator tool goes - a CSV export,
 * a bulk send, a repair pass. `/tools` on its own redirects into the first of
 * them rather than drawing an index of one card.
 */
import { Navigate, Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { BulkPdfPage } from "./BulkPdfPage";

export function ToolsSection({ user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route index element={<Navigate to="/tools/bulk-pdf" replace />} />
      <Route path="bulk-pdf" element={<BulkPdfPage user={user} />} />
      <Route path="*" element={<Navigate to="/tools/bulk-pdf" replace />} />
    </Routes>
  );
}
